import { Injectable } from "@angular/core";
import { AsyncSubject, Observable, Subject } from "rxjs";
import { Breadcrumbs } from "../models/breadcrumbs.model";

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbsService{
    private asyncBreadcrumbs$: AsyncSubject<Array<Breadcrumbs>> = new AsyncSubject();
    private breadcrumbs$: Subject<Array<Breadcrumbs>> = new Subject();
    public breadcrumbs: Array<Breadcrumbs> = [];

    constructor(){}

    public set(bc:Array<Breadcrumbs>): void{
        this.breadcrumbs = bc;
        this.breadcrumbs$.next(this.breadcrumbs);
    }
    public get$(): Observable<Array<Breadcrumbs>>{
        return this.breadcrumbs$.asObservable();
    }
    public getAsync$(): Observable<Array<Breadcrumbs>>{
        return this.asyncBreadcrumbs$.asObservable();
    }
    public setAsync(bc:Array<Breadcrumbs>): void{
        this.breadcrumbs = bc;
        this.asyncBreadcrumbs$.next(this.breadcrumbs);
        this.asyncBreadcrumbs$.complete();
      }
}